module.exports = __webpack_public_path__ + "static/media/icon-big-data.78a472fb.png";